import { MergedStation } from './../../../shared/model/merged-station.interface';
import { StationService } from './../../../core/services/station.service';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { IhmLoadingIndicatorService, ToastService } from '@ihm-software/ihm-ui-common-angular-10';
import { chain } from 'lodash';
import { forkJoin } from 'rxjs';
import { delay, finalize } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { Subject } from 'rxjs/Subject';
import { StationSourceData } from 'src/app/shared/model/station-source-request';
import { SidebarStationService } from 'src/app/sidebar-station/sidebar-station.service';

import { Station } from '../../../core/models/station';
import { SearchFiltersService } from '../../../search-filters/search-filters.service';
import { ConfirmationDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { MarketFormatPipe } from '../../../shared/market-format.pipe';
import { Market } from '../../../shared/model/market.interface';
import { StationRequest } from '../../../shared/model/station-request.interface';
import { VeritoneStation } from '../../../shared/model/veritone-station.interface';
import { MarketService } from '../../../shared/service/market.service';
import { SingleDropboxComponent, SingleDropboxData } from '../../../shared/single-dropbox/single-dropbox.component';
import { StationUtilsService } from '../../../shared/utils/station-utils.service';
import { StationManagementService } from '../../station-management.service';
import { CustomSourceDialogComponent } from '../custom-source-dialog/custom-source-dialog.component';
import { StationSource } from './../../../core/models/station-source';
import { FlatNode } from './../../../sidebar-station/model/node.interface';

@Component({
  selector: 'app-station-settings',
  templateUrl: './station-settings.component.html',
  styleUrls: ['./station-settings.component.scss']
})
export class StationSettingsComponent implements OnInit, OnDestroy {
  
  veritoneStationIdControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(9),
    Validators.pattern('[0-9]*')
  ]);
  
  @ViewChild(MatTable) table: MatTable<StationSource>;

  @ViewChild('dropboxMediaMonitors', { static: true })
  dropboxMediaMonitors: SingleDropboxComponent;
  stationMMControl = new FormControl('', [Validators.required]);
  stationMediaMonitors: Station;
  containsMM: boolean = false;

  @ViewChild('dropboxStream', { static: true })
  dropboxStream: SingleDropboxComponent;
  stationStreamControl = new FormControl('', [Validators.required]);
  stationStream: Station;
  containsMainStream: boolean = false;

  @ViewChild('dropboxMarket', { static: true })
  dropboxMarket: SingleDropboxComponent;
  marketControl = new FormControl('', [Validators.required]);
  market: any;

  @ViewChild('dropboxVeritoneMarket', { static: true })
  dropboxVeritoneMarket: SingleDropboxComponent;
  veritoneMarketControl = new FormControl('', [Validators.required]);
  veritoneMarket: any;
  isVeritoneUpdated = false;

  stations: any;
  stationForm: FormGroup;

  canAddMainStream: boolean = false;
  canAddMediaMonitors: boolean = false;

  isMediaMonitorDisabled = true;
  showCustomSources = false;
  isMarketDisabled = false;
  listStationSideBar = [];
  stationsMediaMonitorsFiltered: Station[];
  stationsStreamFiltered: Station[];
  isUpdating = false;
  isDisabled = false;
  arrayIDStationOnSIA = [];
  listVTStation: VeritoneStation[] = [];
  listVTMarket = [];
  isErrorOnVeritoneMarket = false;

  displayedColumns: string[] = ['type', 'stationId', 'action'];
  dataSource: Station[] = [];

  stationGroupedByName: any;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private readonly marketService: MarketService,
    private readonly stationManagementService: StationManagementService,
    private readonly marketPipe: MarketFormatPipe,
    private readonly searchFiltersService: SearchFiltersService,
    public readonly dialog: MatDialog,
    private readonly toastService: MatSnackBar,
    private readonly stationService: StationService,
    private readonly loaderService: IhmLoadingIndicatorService,
    private readonly toastServiceToast: ToastService,
    private readonly sidebarStationService: SidebarStationService,
    private readonly stationUtilsService: StationUtilsService

  ) {
  }
  ngOnDestroy(): void {
    this.sidebarStationService.setSidebarListInMemory([]);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.unsubscribe();
  }

  ngOnInit() {
    this.stationForm = new FormGroup({
      market: this.marketControl,
      stationMM: this.stationMMControl,
      stationStream: this.stationStreamControl,
      veritoneStationId: this.veritoneStationIdControl,
      veritoneMarket: this.veritoneMarketControl
    });

    this.reloadAllStationsAndMarkets();

    this.stationForm.markAsTouched();

    this.sidebarStationService.selectionItem.pipe(takeUntil(this.ngUnsubscribe)).subscribe((item: FlatNode) => {
      if (item?.value) {
        this.stationToUpdate(item.value);
      }
    });

    this.stationManagementService.createEvent.pipe(takeUntil(this.ngUnsubscribe)).subscribe((isCreating: boolean) => {
      this.canAddMainStream = false;
      this.canAddMediaMonitors = false;
      if (isCreating) {
        this.createStationAndCancel();
      }
    });
  }


  private setStreamDropboxFiltered() {
    if (this.market && (!this.stationStream || this.stationMediaMonitors?.name !== this.stationStream?.name)) {
      let stationStreamMarketFiltered = this.stationsStreamFiltered

      if (this.stationMediaMonitors){
        this.stationStream = null;
        stationStreamMarketFiltered = stationStreamMarketFiltered.filter((station: Station) => station.name === this.stationMediaMonitors.name);
      }

      this.dropboxStream.setList(stationStreamMarketFiltered);
    }
  }

  private setMediaMonitorsDropboxFiltered() {
    if (this.market && (!this.stationMediaMonitors || this.stationStream?.name !== this.stationMediaMonitors?.name)) {
      let stationMediaMonitorsMarketFiltered = this.stationsMediaMonitorsFiltered
      
      if (this.stationStream){
        this.stationMediaMonitors = null;
        stationMediaMonitorsMarketFiltered = stationMediaMonitorsMarketFiltered.filter((station: Station) => station.name == this.stationStream.name);
      }

      this.dropboxMediaMonitors.setList(stationMediaMonitorsMarketFiltered);
    }
  }

  private setStationDropbox() {
    this.setStreamDropboxFiltered();
    this.setMediaMonitorsDropboxFiltered();
  }

  optionSelected(mergedStation: MergedStation) {
    this.cleanAllMM();
    this.cleanAllStream();

    this.setStationDropbox();

    if (mergedStation) {
      if (this.stationUtilsService.findSourceMediaMonitors(mergedStation.stationSources)) {
        this.enableMediaMonitor(mergedStation);
      }

      if (this.stationUtilsService.findSourceMainStream(mergedStation.stationSources)) {
        this.enableStream(mergedStation);
      }
    }
  }

  enableMediaMonitor(mergedStation: MergedStation) {
    if (!this.isUpdating || mergedStation != null) {
      const sourceMM: StationSource = this.stationUtilsService.findSourceMediaMonitors(mergedStation.stationSources);
      const stationId = mergedStation.mapStationSources.get(sourceMM.id);

      this.canAddMediaMonitors = false;

      const dropBoxData: SingleDropboxData = {
        id: stationId,
        name: mergedStation.name,
        model: mergedStation.model,
        mergedStation: mergedStation
      }

      this.dropboxMediaMonitors.setList([dropBoxData]);
      this.stationMediaMonitors = mergedStation.model.find(station => station.id === stationId);
      this.stationMMControl.setValue(this.stationUtilsService.findStationMediaMonitors(mergedStation.model));
    }
  }

  enableStream(mergedStation: MergedStation) {
    if (!this.isUpdating || mergedStation != null) {
      const sourceStream: StationSource = this.stationUtilsService.findSourceMainStream(mergedStation.stationSources);
      const stationId = mergedStation.mapStationSources.get(sourceStream.id);

      this.canAddMainStream = false;
      const dropBoxData: SingleDropboxData = {
        id: stationId,
        name: mergedStation.name,
        model: mergedStation.model,
        mergedStation: mergedStation
      }

      this.showCustomSources = true;
      this.dropboxStream.setList([dropBoxData]);
      this.stationStream = mergedStation.model.find(station => station.id === stationId);
      this.stationStreamControl.setValue(this.stationStream);
    }
  }

  selectMarket(market) {
    this.market = market;
    this.marketControl.setValue(this.market);
    this.stationMediaMonitors = null;
    this.stationStream = null;
    this.optionSelected(null);
  }

  selectMainStreamStation(station) {
    this.stationStreamControl.setValue(station);
    this.stationStream = station;
    this.setMediaMonitorsDropboxFiltered();// yes it is inverted, because when we select a stream, we want to filter the media monitors
  }

  selectMediaMonitorsStation(station) {
    this.stationMMControl.setValue(station);
    this.stationMediaMonitors = station;
    this.setStreamDropboxFiltered();// yes it is inverted, because when we select a media monitors, we want to filter the main stream
  }

  selectVeritoneMarket(market) {
    this.veritoneMarket = market;
    this.veritoneMarketControl.setValue(this.veritoneMarket);
  }

  stationToUpdate(mergedStation: MergedStation) {
    this.isUpdating = true;
    this.isDisabled = true;
    this.isMarketDisabled = true;
    this.isVeritoneUpdated = false;
    this.veritoneStationIdControl.setValue('');

    this.canAddMainStream = this.stationUtilsService.findSourceMainStream(mergedStation.stationSources) == null;
    this.canAddMediaMonitors = this.stationUtilsService.findSourceMediaMonitors(mergedStation.stationSources) == null;

    const vtStationId = this.listVTStation.filter(
      (st) => mergedStation.id.find(id => +id === st.stationId) != null
    );

    if (vtStationId?.length) {
      this.veritoneStationIdControl.setValue(vtStationId[0].vtStationId);

      const vtMarket = this.listVTMarket.filter(
        (market) => market.name === vtStationId[0].market
      );

      this.veritoneMarket = vtMarket.length > 0 ? vtMarket[0] : '';
    } else {
      this.veritoneMarket = undefined;
    }

    const marketReplacedName = this.dropboxMarket
      .getAllItems()
      .filter((market) => this.replaceNameMarket(market) === mergedStation.market);

    this.market =
      marketReplacedName.length > 0 ? marketReplacedName[0] : this.fillMarket(mergedStation.market);

    this.optionSelected(mergedStation);
    this.marketControl.setValue(this.market);
    this.veritoneMarketControl.setValue(this.veritoneMarket);
    this.attacheStreamStationSource();
  }

  createStationAndCancel() {
    this.veritoneMarket = undefined;
    this.market = null;
    this.isUpdating = false;
    this.isDisabled = false;
    this.isMarketDisabled = false;
    this.isVeritoneUpdated = false;

    this.marketControl.setValue('');
    this.veritoneStationIdControl.setValue('');
    this.veritoneMarketControl.setValue('');

    this.cleanAllMM();
    this.cleanAllStream();
  }

  cleanAllMM() {
    this.stationMMControl.setValue('');
    this.dropboxMediaMonitors.setList([]);
    this.canAddMediaMonitors = false;
    this.isMediaMonitorDisabled = false;
    this.stationMediaMonitors = null;
  }

  cleanAllStream() {
    this.stationStreamControl.setValue('');
    this.dropboxStream.setList([]);
    this.canAddMainStream = false;
    this.showCustomSources = false;
    this.stationStream = null;
    this.dataSource = [];
  }

  submit() {
    this.loaderService.toggle(true);

    this.veritoneStationIdControl.setValue(
      +this.veritoneStationIdControl.value
    );

    forkJoin([
      this.stationManagementService.saveStation(this.mapperFormToMediaMonitors()),
      this.stationManagementService.saveStation(this.mapperFormToStream())]
    ).pipe(finalize(() => { this.loaderService.toggle(false) }))
      .subscribe(([mediaMonitors, stream]) => {
        this.reloadAllStationsAndMarkets();
        this.showCustomSources = stream;

        this.canAddMainStream = stream && !this.stationStream?.id;
        this.canAddMediaMonitors = mediaMonitors && !this.stationMediaMonitors?.id;

        if (mediaMonitors || stream) {
          this.showToastMessage(
            this.isUpdating ? 'Update success' : 'Save success',
            'Ok'
          );
        } else {
          this.showToastMessage(
            this.isUpdating ? 'Error on Updated' : 'Error on Save',
            'Ok'
          );
        }
      }, (error) => {
        console.error(error);
        this.showToastMessage(
          this.isUpdating ? 'Error on Updated' : 'Error on Save',
          'Ok'
        );
      });
  }

  removeStationMediaMonitors() {
    const dialogRef = this.dialog.open(StationDeleteDialogComponent, {
      width: '500px',
      data: { name: this.stationMMControl.value.name }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loaderService.toggle(true);
        let station = this.stationMMControl.value;
        this.stationManagementService
          .deleteConfigStation(station.id)
          .pipe(finalize(() => { this.loaderService.toggle(false) }))
          .subscribe((response) => {
            if (response) {
              this.reloadAllStationsAndMarkets();
              this.cleanAllMM();
              this.showToastMessage('Delete success', 'Ok');
            } else {
              this.showToastMessage('Error on Delete', 'Ok');
            }
          });
      }
    }, (error) => {
      console.error(error)
    });
  }

  hideStationMainStream() {
    this.canAddMainStream = false;
  }


  hideStationMediaMonitors() {
    this.canAddMediaMonitors = false;
  }

  removeStationMainStream() {
    const dialogRef = this.dialog.open(StationDeleteDialogComponent, {
      width: '500px',
      data: { name: this.stationStreamControl.value.name }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result) {
          this.loaderService.toggle(true);
          const mainStreamStation: Station = this.stationStreamControl.value;
          const customSourcesStations: Station[] = this.dataSource;

          if (customSourcesStations.length > 0) {
            const deleteCustomSources$ = (stationId) => { return forkJoin(stationId.map(id => this.stationManagementService.deleteStation(id))) };
            deleteCustomSources$(customSourcesStations.map(station => station.id)).subscribe((response) => {
              this.deleteStreamStationConfig(mainStreamStation);
            }, (error) => {
              this.showToastMessage('Error on Delete', 'Ok');
              console.error(error)
            });

          }
          else {
            this.deleteStreamStationConfig(mainStreamStation);
          }
        }
      });
  }

  private deleteStreamStationConfig(mainStreamStation: Station) {
    this.stationManagementService.deleteConfigStation(mainStreamStation.id)
      .pipe(finalize(() => { this.loaderService.toggle(false) }))
      .subscribe((response) => {
        this.reloadAllStationsAndMarkets();
        this.cleanAllStream();

        if (response) {
          this.showToastMessage('Delete success', 'Ok');
        } else {
          this.showToastMessage('Error on Delete', 'Ok');
        }
      });
  }

  loadingVeritoneMarket() {
    this.loaderService.toggle(true);
    this.stationManagementService.getVeritoneMarkets().subscribe(
      (values) => {
        this.fillVeritoneMarkets(values);
        this.isErrorOnVeritoneMarket = false;
      },
      (error) => console.error(error),
      () => {
        this.loaderService.toggle(false);
      }
    );
  }

  addStationMediaMonitors() {
    if (this.stationMMControl?.value?.stationSource) {
      this.showToastMessage("Media Monitors is already a source for this station", "ok");
      return;
    }

    this.canAddMediaMonitors = true;
    this.setMediaMonitorsDropboxFiltered();
  }

  addStationMainStream() {//AKA Sound+
    if (this.stationStreamControl?.value?.stationSource) {

      this.showToastMessage("The main stream source was already chosen to this station", "ok");
      return;
    }
    this.canAddMainStream = true;
    this.setStreamDropboxFiltered();
  }

  addCustomSource() {
    this.stationManagementService.stationSourceList().subscribe(list => {
      const stationSourcesAlreadyAdded = this.dataSource.map(data => data.stationSource.id);
      const sourcesDialogList = list.filter(source => !stationSourcesAlreadyAdded.includes(source.id));

      if (sourcesDialogList.length === 0) {
        this.showToastMessage('All custom sources already added', 'Ok');
      } else {
        const dialogRef = this.dialog.open(CustomSourceDialogComponent, {
          width: '300px',
          data: {
            name: this.stationStreamControl.value.name
            , stationSources: sourcesDialogList
          }
        });

        dialogRef.afterClosed().subscribe((sourceSelected) => {
          if (sourceSelected) {

            const isSourceWasAdded = this.dataSource.find(source => source.stationSource.id === sourceSelected.id);
            const stationSourceSoundPlus = this.stationStreamControl.value.stationSource;

            if (stationSourceSoundPlus)
              if (!isSourceWasAdded) {

                const stationSourceToAdd: StationSourceData = {
                  stationId: this.stationStreamControl.value.id,
                  sourceId: sourceSelected.id,
                  stationName: this.stationStreamControl.value.name,
                  id: null,
                };

                this.addSourceToStation(stationSourceToAdd);
              } else {
                this.showToastMessage('This Source is already assigned to this Station.', 'Ok');
              }
          }
        });
      }
    });
  }

  private addSourceToStation(stationSourceToAdd: StationSourceData) {

    this.loaderService.toggle(true);
    this.stationManagementService.addSourceToStation(stationSourceToAdd)
      .pipe(finalize(() => this.loaderService.toggle(false)))
      .subscribe((resp) => {
        if (resp) {
          stationSourceToAdd.id = resp.id;
          this.dataSource = [...this.dataSource, resp];
          this.reloadAllStationsAndMarkets();
          this.showToastMessage('Source added successfully', 'Ok');
          this.isMarketDisabled = true;
        }else{
          //Probably due to MainStream duplication
          //go to kibana, add a application filter to lyra-config-svc and search 'addSourceToStation called'
          this.showToastMessage('Error on adding source', 'Ok');
        }
      },
        (error) => {
          this.showToastMessage('Error on adding source', 'Ok');
          console.error(error);
        });
  }


  deleteStation(element: Station) {
    if (!element.id) {
      this.dataSource = this.dataSource.filter(source => source.stationSource.id !== element.stationSource.id);
    } else {
      let text = 'Are you sure you want to remove this Custom Source? This action is  <b>IRREVERSIBLE</b> <br/>';
      text += `<br/>Source Type: <b>${element.stationSource.name}</b>`;
      text += `<br/>Station Id: <b>${element.id}</b> `;
      text += `<br/>Station: <b>${element.name}</b> `;
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: 'auto',
        height: 'auto',
        data: { text, cancelText: 'No' }
      });
      dialogRef.afterClosed().subscribe((result) => {

        if (result) {
          this.loaderService.toggle(true);

          this.stationManagementService
            .deleteStation(element.id)
            .subscribe((response) => {
              if (response) {
                this.reloadAllStationsAndMarkets();
                this.dataSource = this.dataSource.filter(source => source.stationSource.id !== element.stationSource.id);

                this.showToastMessage('Custom source deleted!', 'Ok');
              }
              this.loaderService.toggle(false);
            });

        } else {
          this.loaderService.toggle(false);
        }
      });
    }
    this.table.renderRows();
  }

  isCustomSourceEnabled(): boolean {
    return !this.marketControl.valid || !this.stationStreamControl.valid;
  }

  private reloadAllStationsAndMarkets() {
    this.loaderService.toggle(true);

    forkJoin([
      this.stationManagementService.findIdStationsOnSIA(),
      this.searchFiltersService.loadAllStationsNoCache(),
      this.marketService.getAllMarkets(),
      this.stationManagementService.getVeritoneMarkets(),
      this.stationManagementService.getVeritoneStations()
    ])
      .pipe(finalize(() => this.loaderService.toggle(false)))
      .subscribe(
        (values) => {
          this.arrayIDStationOnSIA = values[0];
          const stations = values[1];
          this.fillStationStreamAndMediaMonitors(values[1]);
          this.setTheRaptorMarkets(values[2]);
          this.fillStationSidebar(stations, this.arrayIDStationOnSIA);

          this.fillVeritoneMarkets(values[3]);
          this.listVTStation = values[4];
        },
        (error) => {
          console.error('Error on reloadAllStationsAndMarkets ', error);
        }
      );
  }

  private fillVeritoneMarkets(values: []) {
    if (!values) {
      this.isErrorOnVeritoneMarket = true;
      values = [];
    }

    this.listVTMarket = values.map(
      (marketVeritone: { market: string }, index) => {
        return {
          id: index,
          name: marketVeritone.market,

        };
      }
    );
    this.dropboxVeritoneMarket.setList(this.listVTMarket);
  }

  private fillStationSidebar(
    stations: Station[],
    arrayIDStationOnSIA: string[]
  ) {

    this.stationGroupedByName = chain(stations)
      .groupBy('name')
      .value();

    stations = stations.filter((station) => {
      return arrayIDStationOnSIA.indexOf(station.id) > -1;
    });

    const distinctFilteredMarkets = new Set(
      stations.map((item) => item.market).sort()
    );
    const mergedStations: MergedStation[] = this.stationService.groupStationByName(stations);

    this.listStationSideBar = [...distinctFilteredMarkets]
      .filter(market => mergedStations.filter((x) => x.market === market).length > 0)
      .map((market) => {
        return {
          name: this.marketPipe.transform(market)
          , children: mergedStations.filter((x) => x.market === market)
        };
      });

    this.sidebarStationService.setSidebarListInMemory(this.listStationSideBar);
  }

  private fillStationStreamAndMediaMonitors(stations: Station[]) {
    const stationsFiltered = stations.filter((station) => {
      return this.arrayIDStationOnSIA.indexOf(station.id) <= -1;
    });

    this.stationsMediaMonitorsFiltered =
      this.stationUtilsService.filterStationMediaMonitors(stationsFiltered);
    this.stationsStreamFiltered =
      this.stationUtilsService.filterStationStream(stationsFiltered);
  }

  private setTheRaptorMarkets(markets: Market[]) {
    this.dropboxMarket.setList(
      markets.map((marketFilter: Market) => {
        return {
          id: marketFilter.Site_ID,
          name: marketFilter.sitename
        };
      })
    );
  }

  private fillMarket(marketName: string) {
    const newMarket = {
      id: this.dropboxMarket.getAllItems().length,
      name: marketName
    };
    this.dropboxMediaMonitors.setList([...this.dropboxMarket.getAllItems()]);
    this.dropboxStream.setList([...this.dropboxMarket.getAllItems()]);

    return '';
  }

  private replaceNameMarket(market: SingleDropboxData) {
    return market.name.toUpperCase().replace(/ +/g, '').replace(',', '-');
  }

  private showToastMessage(
    text: string,
    actionText: string
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.toastService.open(text, actionText, {
      panelClass: ['mat-elevation-z3'],
      duration: 15000
    });
  }

  private mapperFormToMediaMonitors(): StationRequest {
    if ((this.isVeritoneUpdated ||this.canAddMediaMonitors) && this.stationMMControl.valid)
      return {
        ...this.stationMediaMonitors,
        vtStationId: this.veritoneStationIdControl.value,
        vtMarket: this.veritoneMarketControl?.value?.name,
        customSources: this.dataSource
      };

    return null;
  }

  private mapperFormToStream(): StationRequest {
    if ((this.isVeritoneUpdated || this.canAddMainStream) && this.stationStreamControl.valid)
      return {
        ...this.stationStream,
        vtStationId: this.veritoneStationIdControl.value,
        vtMarket: this.veritoneMarketControl?.value?.name,
        customSources: this.dataSource
      };
    return null;
  }

  private attacheStreamStationSource(): void {
    if (this.stationStreamControl?.value?.name) {
      const stationSourceArray: [] = this.stationGroupedByName[this.stationStreamControl.value.name];

      if (stationSourceArray.length) {

        const stationSource = stationSourceArray.filter(
          (station: Station) => {
            return !this.stationUtilsService.isSourceMediaMonitors(station.stationSource)
              && !this.stationUtilsService.isSourceSoundPlus(station.stationSource)
          });
        this.dataSource = stationSource;
      }
    }
  }

  isSubmitButtonDisable(): boolean {
    return !(
      (this.marketControl.valid && this.veritoneStationIdControl.valid && this.veritoneMarketControl.valid)
      && (((this.canAddMainStream || this.isVeritoneUpdated) && this.stationStreamControl.valid)
        || ((this.canAddMediaMonitors || this.isVeritoneUpdated) && this.stationMMControl.valid))
    )
  }

  onChangeVeritone() {
    this.isVeritoneUpdated = true;
  }

}


/**
 * Dialog component
 */
@Component({
  selector: 'app-delete-dialog',
  templateUrl: 'delete-dialog.html'
})
export class StationDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<StationDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
